/** @jsxImportSource @emotion/react */
import { css, keyframes, SerializedStyles } from "@emotion/react";

const subtleShakeAnimation = keyframes`
  0%,
  56%,
  100% {
    transform: translate3d(0, 0, 0) rotate(0deg);
  }
  60% {
    transform: translate3d(-3px, -3px, 0) rotate(-2deg);
  }
  62% {
    transform: translate3d(3px, 3px, 0) rotate(2deg);
  }
  64% {
    transform: translate3d(0, 0, 0) rotate(0deg);
  }
  66% {
    transform: translate3d(-3px, -2px, 0) rotate(-1.6deg);
  }
  68% {
    transform: translate3d(2px, 3px, 0) rotate(1.2deg);
  }
  70% {
    transform: translate3d(0, 0, 0) rotate(0deg);
  }
`;

export const getShakeAnimationCss = (): SerializedStyles => {
  return css`
    animation: ${subtleShakeAnimation} 3s ease-in-out infinite;

    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  `;
};
